import { render } from "./HumanPerceptionReport.vue?vue&type=template&id=5fb13fc6&scoped=true"
import script from "./HumanPerceptionReport.vue?vue&type=script&lang=js"
export * from "./HumanPerceptionReport.vue?vue&type=script&lang=js"

import "./HumanPerceptionReport.vue?vue&type=style&index=0&id=5fb13fc6&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5fb13fc6"]])

export default __exports__